var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "validation-observer",
    { ref: "conflito", attrs: { tag: "div" } },
    [
      _c(
        "el-card",
        [
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c("app-divider", { attrs: { label: "Interessado" } }),
                  _c("el-row", {
                    staticClass: "margin-top",
                    attrs: { type: "flex", justify: "start" }
                  }),
                  !_vm.tipoChanged
                    ? _c(
                        "el-radio-group",
                        {
                          attrs: { disabled: _vm.isEdicao },
                          model: {
                            value: _vm.setPessoaTipo,
                            callback: function($$v) {
                              _vm.setPessoaTipo = $$v
                            },
                            expression: "setPessoaTipo"
                          }
                        },
                        [
                          _c("el-radio-button", { attrs: { label: "PF" } }, [
                            _c("i", { staticClass: "fal fa-user" }),
                            _vm._v(" Pessoa Física")
                          ]),
                          _c("el-radio-button", { attrs: { label: "PJ" } }, [
                            _c("i", { staticClass: "fal fa-building" }),
                            _vm._v(" Pessoa Jurídica")
                          ])
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "el-row",
                    [
                      _c("app-divider", {
                        attrs: {
                          label:
                            _vm.conflito.interessado.tipo == "PF"
                              ? "Pessoa Física"
                              : "Pessoa Jurídica"
                        }
                      })
                    ],
                    1
                  ),
                  _vm.conflito.interessado.tipo === "PF"
                    ? _c(
                        "el-row",
                        {
                          key: "pessoaFisica",
                          staticClass: "margin-top-15",
                          attrs: { gutter: 30, type: "flex" }
                        },
                        [
                          _c(
                            "el-col",
                            { staticClass: "boxInput", attrs: { span: 12 } },
                            [
                              _c("validation-provider", {
                                attrs: {
                                  mode: "lazy",
                                  rules: "required|cpf_cnpj",
                                  name: "cadastroUsuario/cpf"
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function(ref) {
                                        var errors = ref.errors
                                        return [
                                          _c("app-label", {
                                            attrs: {
                                              label: "CPF:",
                                              required: true
                                            }
                                          }),
                                          _c("el-input", {
                                            directives: [
                                              {
                                                name: "mask",
                                                rawName: "v-mask",
                                                value: ["###.###.###-##"],
                                                expression: "['###.###.###-##']"
                                              }
                                            ],
                                            staticClass: "input",
                                            class: { erro: errors.length },
                                            attrs: {
                                              "suffix-icon": "el-icon-search",
                                              disabled: _vm.isEdicao
                                            },
                                            on: { blur: _vm.buscarDados },
                                            model: {
                                              value:
                                                _vm.conflito.interessado
                                                  .pessoaFisica.cpf,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.conflito.interessado
                                                    .pessoaFisica,
                                                  "cpf",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "conflito.interessado.pessoaFisica.cpf"
                                            }
                                          }),
                                          _c(
                                            "span",
                                            { staticClass: "help erro" },
                                            [_vm._v(_vm._s(errors[0]))]
                                          )
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  false,
                                  2126482640
                                )
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { staticClass: "boxInput", attrs: { span: 12 } },
                            [
                              _c("validation-provider", {
                                attrs: {
                                  mode: "lazy",
                                  rules: "required",
                                  name: "cadastroUsuario/nome"
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function(ref) {
                                        var errors = ref.errors
                                        return [
                                          _c("app-label", {
                                            attrs: {
                                              label: "Nome:",
                                              required: true
                                            }
                                          }),
                                          _c("el-input", {
                                            staticClass: "input",
                                            class: { erro: errors.length },
                                            attrs: {
                                              maxlength: _vm.maxLengthNome
                                            },
                                            on: { blur: _vm.toUpperCase },
                                            model: {
                                              value:
                                                _vm.conflito.interessado
                                                  .pessoaFisica.nome,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.conflito.interessado
                                                    .pessoaFisica,
                                                  "nome",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "conflito.interessado.pessoaFisica.nome"
                                            }
                                          }),
                                          _c(
                                            "span",
                                            { staticClass: "help erro" },
                                            [_vm._v(_vm._s(errors[0]))]
                                          )
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  false,
                                  2472156832
                                )
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _c(
                        "el-row",
                        {
                          key: "pessoaJuridica",
                          staticClass: "margin-top-15",
                          attrs: { gutter: 30, type: "flex" }
                        },
                        [
                          _c(
                            "el-col",
                            { staticClass: "boxInput", attrs: { span: 12 } },
                            [
                              _c("validation-provider", {
                                attrs: {
                                  mode: "lazy",
                                  rules: "required|cpf_cnpj",
                                  name: "cadastroUsuario/cnpj"
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function(ref) {
                                      var errors = ref.errors
                                      return [
                                        _c("app-label", {
                                          attrs: {
                                            label: "CNPJ:",
                                            required: true
                                          }
                                        }),
                                        _c("el-input", {
                                          directives: [
                                            {
                                              name: "mask",
                                              rawName: "v-mask",
                                              value: ["##.###.###/####-##"],
                                              expression:
                                                "['##.###.###/####-##']"
                                            }
                                          ],
                                          staticClass: "input",
                                          class: { erro: errors.length },
                                          attrs: {
                                            "suffix-icon": "el-icon-search",
                                            disabled: _vm.isEdicao
                                          },
                                          on: { blur: _vm.buscarDados },
                                          model: {
                                            value:
                                              _vm.conflito.interessado
                                                .pessoaJuridica.cnpj,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.conflito.interessado
                                                  .pessoaJuridica,
                                                "cnpj",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "conflito.interessado.pessoaJuridica.cnpj"
                                          }
                                        }),
                                        _c(
                                          "span",
                                          { staticClass: "help erro" },
                                          [_vm._v(_vm._s(errors[0]))]
                                        )
                                      ]
                                    }
                                  }
                                ])
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { staticClass: "boxInput", attrs: { span: 12 } },
                            [
                              _c("validation-provider", {
                                attrs: {
                                  mode: "lazy",
                                  rules: "required",
                                  name: "cadastroUsuario/razaoSocial"
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function(ref) {
                                      var errors = ref.errors
                                      return [
                                        _c("app-label", {
                                          attrs: {
                                            label: "Razão Social:",
                                            required: true
                                          }
                                        }),
                                        _c("el-input", {
                                          staticClass: "input",
                                          class: { erro: errors.length },
                                          attrs: {
                                            maxlength: _vm.maxLengthRazaoSocial
                                          },
                                          on: { blur: _vm.toUpperCase },
                                          model: {
                                            value:
                                              _vm.conflito.interessado
                                                .pessoaJuridica.razaoSocial,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.conflito.interessado
                                                  .pessoaJuridica,
                                                "razaoSocial",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "conflito.interessado.pessoaJuridica.razaoSocial"
                                          }
                                        }),
                                        _c(
                                          "span",
                                          { staticClass: "help erro" },
                                          [_vm._v(_vm._s(errors[0]))]
                                        )
                                      ]
                                    }
                                  }
                                ])
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                  _c(
                    "el-row",
                    { staticClass: "margin-top-15", attrs: { gutter: 30 } },
                    [
                      _c(
                        "el-col",
                        { staticClass: "boxInput", attrs: { span: 12 } },
                        [
                          _c("validation-provider", {
                            attrs: {
                              mode: "lazy",
                              rules: "required|email",
                              name: "cadastroUsuario/email"
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function(ref) {
                                  var errors = ref.errors
                                  return [
                                    _c("app-label", {
                                      attrs: {
                                        label: "E-mail:",
                                        required: true
                                      }
                                    }),
                                    _c("el-input", {
                                      staticClass: "input",
                                      class: { erro: errors.length },
                                      attrs: { maxlength: _vm.maxLengthEmail },
                                      model: {
                                        value: _vm.conflito.interessado.email,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.conflito.interessado,
                                            "email",
                                            $$v
                                          )
                                        },
                                        expression: "conflito.interessado.email"
                                      }
                                    }),
                                    _c("span", { staticClass: "help erro" }, [
                                      _vm._v(_vm._s(errors[0]))
                                    ])
                                  ]
                                }
                              }
                            ])
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { staticClass: "boxInput", attrs: { span: 12 } },
                        [
                          _c("validation-provider", {
                            attrs: {
                              mode: "lazy",
                              rules:
                                "required|email_confirmation:@cadastroUsuario/email",
                              name: "cadastroUsuario/emailConfirmacao"
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function(ref) {
                                  var errors = ref.errors
                                  return [
                                    _c("app-label", {
                                      attrs: {
                                        label: "Confirmar e-mail:",
                                        required: true
                                      }
                                    }),
                                    _c("el-input", {
                                      staticClass: "input",
                                      class: { erro: errors.length },
                                      attrs: { maxlength: _vm.maxLengthEmail },
                                      model: {
                                        value:
                                          _vm.conflito.interessado
                                            .confirmaEmail,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.conflito.interessado,
                                            "confirmaEmail",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "conflito.interessado.confirmaEmail"
                                      }
                                    }),
                                    _c("span", { staticClass: "help erro" }, [
                                      _vm._v(_vm._s(errors[0]))
                                    ])
                                  ]
                                }
                              }
                            ])
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    { staticClass: "margin-top-15", attrs: { gutter: 30 } },
                    [
                      _c(
                        "el-col",
                        { staticClass: "boxInput", attrs: { span: 12 } },
                        [
                          _c("app-input-telefone", {
                            attrs: {
                              telefones: _vm.conflito.interessado.telefones,
                              requiredTelefones: true,
                              nomeAba: _vm.isEdicao ? "editUser" : "createUser",
                              observer: this.$refs.conflito
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c("app-endereco", {
                    attrs: {
                      endereco: _vm.conflito.interessado.endereco,
                      nomeAba: "cadastroUsuario",
                      disabledFields: false,
                      upperCaseApply: true,
                      codigoEstado:
                        _vm.conflito.interessado.endereco.municipio
                          .codigoEstado,
                      municipio: _vm.conflito.interessado.endereco.municipio
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c("app-divider", { attrs: { label: "Conflito" } }),
                  _c(
                    "el-row",
                    { staticClass: "margin", attrs: { gutter: 30 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 5 } },
                        [
                          _c("validation-provider", {
                            attrs: {
                              rules: "required",
                              name: "Origem do conflito"
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function(ref) {
                                  var errors = ref.errors
                                  return [
                                    _c("app-label", {
                                      attrs: {
                                        label: "Origem: ",
                                        required: true
                                      }
                                    }),
                                    _c(
                                      "el-select",
                                      {
                                        staticClass: "input",
                                        class: { erro: errors.length },
                                        staticStyle: { width: "100%" },
                                        model: {
                                          value: _vm.conflito.origem,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.conflito,
                                              "origem",
                                              $$v
                                            )
                                          },
                                          expression: "conflito.origem"
                                        }
                                      },
                                      _vm._l(_vm.origensConflito, function(
                                        origem
                                      ) {
                                        return _c("el-option", {
                                          key: origem.codigo,
                                          attrs: {
                                            label: origem.descricao,
                                            value: origem.codigo
                                          }
                                        })
                                      }),
                                      1
                                    ),
                                    _c("span", { staticClass: "help erro" }, [
                                      _vm._v(_vm._s(errors[0]))
                                    ])
                                  ]
                                }
                              }
                            ])
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 5 } },
                        [
                          _c("app-label", {
                            attrs: {
                              label: "Número do processo: ",
                              required: false
                            }
                          }),
                          _c("el-input", {
                            model: {
                              value: _vm.conflito.numeroProcesso,
                              callback: function($$v) {
                                _vm.$set(_vm.conflito, "numeroProcesso", $$v)
                              },
                              expression: "conflito.numeroProcesso"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 5 } },
                        [
                          _c("app-label", {
                            attrs: {
                              label: "Tipo de processo: ",
                              required: false
                            }
                          }),
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              model: {
                                value: _vm.conflito.tipoProcesso.id,
                                callback: function($$v) {
                                  _vm.$set(_vm.conflito.tipoProcesso, "id", $$v)
                                },
                                expression: "conflito.tipoProcesso.id"
                              }
                            },
                            _vm._l(_vm.tiposProcessos, function(tipo) {
                              return _c("el-option", {
                                key: tipo.id,
                                attrs: { label: tipo.nome, value: tipo.id }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 5 } },
                        [
                          _c("app-label", {
                            attrs: { label: "Setor: ", required: false }
                          }),
                          _c("el-input", {
                            attrs: { type: "text" },
                            model: {
                              value: _vm.conflito.setor,
                              callback: function($$v) {
                                _vm.$set(_vm.conflito, "setor", $$v)
                              },
                              expression: "conflito.setor"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 4 } },
                        [
                          _c("app-label", {
                            attrs: {
                              label: "N° de famílias: ",
                              required: false
                            }
                          }),
                          _c("el-input", {
                            attrs: { type: "number" },
                            model: {
                              value: _vm.conflito.numeroFamilias,
                              callback: function($$v) {
                                _vm.$set(_vm.conflito, "numeroFamilias", $$v)
                              },
                              expression: "conflito.numeroFamilias"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    { staticClass: "margin", attrs: { gutter: 30 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 5 } },
                        [
                          _c("validation-provider", {
                            attrs: {
                              rules: "required",
                              name: "Áreas/imóveis/comunidades"
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function(ref) {
                                  var errors = ref.errors
                                  return [
                                    _c("app-label", {
                                      attrs: {
                                        label: "Áreas/imóveis/comunidades: ",
                                        required: true
                                      }
                                    }),
                                    _c("el-input", {
                                      staticClass: "input",
                                      class: { erro: errors.length },
                                      attrs: { type: "text" },
                                      model: {
                                        value:
                                          _vm.conflito.areaImovelComunidade,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.conflito,
                                            "areaImovelComunidade",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "conflito.areaImovelComunidade"
                                      }
                                    }),
                                    _c("span", { staticClass: "help erro" }, [
                                      _vm._v(_vm._s(errors[0]))
                                    ])
                                  ]
                                }
                              }
                            ])
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 5 } },
                        [
                          _c("app-label", {
                            attrs: {
                              label: "Jurisdição/Dominialidade: ",
                              required: false
                            }
                          }),
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              model: {
                                value: _vm.conflito.jurisdicao,
                                callback: function($$v) {
                                  _vm.$set(_vm.conflito, "jurisdicao", $$v)
                                },
                                expression: "conflito.jurisdicao"
                              }
                            },
                            _vm._l(_vm.jurisdicao, function(tipo) {
                              return _c("el-option", {
                                key: tipo.codigo,
                                attrs: {
                                  label: tipo.descricao,
                                  value: tipo.codigo
                                }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 5 } },
                        [
                          _c("validation-provider", {
                            attrs: {
                              rules: "required",
                              name: "Municipio conflito"
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function(ref) {
                                  var errors = ref.errors
                                  return [
                                    _c("app-label", {
                                      attrs: {
                                        label: "Munícipio: ",
                                        required: true
                                      }
                                    }),
                                    _c(
                                      "el-select",
                                      {
                                        staticClass: "input",
                                        class: { erro: errors.length },
                                        staticStyle: { width: "100%" },
                                        model: {
                                          value: _vm.conflito.municipio.id,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.conflito.municipio,
                                              "id",
                                              $$v
                                            )
                                          },
                                          expression: "conflito.municipio.id"
                                        }
                                      },
                                      _vm._l(_vm.municipios, function(
                                        municipio
                                      ) {
                                        return _c("el-option", {
                                          key: municipio.id,
                                          attrs: {
                                            label: municipio.nome,
                                            value: municipio.id
                                          }
                                        })
                                      }),
                                      1
                                    ),
                                    _c("span", { staticClass: "help erro" }, [
                                      _vm._v(_vm._s(errors[0]))
                                    ])
                                  ]
                                }
                              }
                            ])
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    { staticClass: "margin", attrs: { gutter: 30 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c("validation-provider", {
                            attrs: {
                              rules: "required",
                              name: "Descrição do caso"
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function(ref) {
                                  var errors = ref.errors
                                  return [
                                    _c("app-label", {
                                      attrs: {
                                        label: "Descrição do caso: ",
                                        required: true
                                      }
                                    }),
                                    _c("el-input", {
                                      staticClass: "input",
                                      class: { erro: errors.length },
                                      attrs: { type: "textarea", rows: 4 },
                                      model: {
                                        value: _vm.conflito.descricaoCaso,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.conflito,
                                            "descricaoCaso",
                                            $$v
                                          )
                                        },
                                        expression: "conflito.descricaoCaso"
                                      }
                                    }),
                                    _c("span", { staticClass: "help erro" }, [
                                      _vm._v(_vm._s(errors[0]))
                                    ])
                                  ]
                                }
                              }
                            ])
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c("app-label", {
                    attrs: {
                      label:
                        "Possui o georreferenciamento do imóvel de acordo com as normas técnicas em vigência?",
                      required: true
                    }
                  }),
                  _c("validation-provider", {
                    attrs: {
                      rules: "required",
                      name: "Possui georreferenciamento"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(ref) {
                          var errors = ref.errors
                          return [
                            _c(
                              "el-radio-group",
                              {
                                staticClass: "input padding",
                                class: { erro: errors.length },
                                model: {
                                  value: _vm.conflito.possuiGeorreferenciamento,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.conflito,
                                      "possuiGeorreferenciamento",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "conflito.possuiGeorreferenciamento"
                                }
                              },
                              [
                                _c("el-radio", { attrs: { label: true } }, [
                                  _vm._v("Sim")
                                ]),
                                _c("el-radio", { attrs: { label: false } }, [
                                  _vm._v("Não")
                                ])
                              ],
                              1
                            )
                          ]
                        }
                      }
                    ])
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            [
              _vm.conflito.possuiGeorreferenciamento
                ? _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c("app-documentos", {
                        attrs: {
                          aba: "Georreferenciamento",
                          isAnalise: true,
                          idUploadDocumento: "documentoGeorreferenciamento",
                          titulo: "Georreferenciamento",
                          maxSize: 25000,
                          "valid-extensions": _vm.extensoes,
                          documentos: _vm.documentos,
                          tiposDocumentos: _vm.tipoDocumentos,
                          tiposDocumentosObrigatorios:
                            _vm.tipoDocumentosObrigatorios,
                          pecasTecnicas: true,
                          observer: this.$refs.conflito
                        },
                        on: {
                          mudaTipo: _vm.mudaTipo,
                          setDadosPlanilha: _vm.setDadosPlanilha,
                          removedDoc: _vm.removeFile,
                          addedDoc: _vm.addedDoc
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.conflito.possuiGeorreferenciamento === false
                ? _c(
                    "el-col",
                    { staticClass: "margin", attrs: { span: 24 } },
                    [
                      _c("mapa-analise-geomensor", {
                        attrs: {
                          localizacoes: _vm.conflito.geometrias,
                          tipoCadastro: "NAO_ONEROSO",
                          name: "Geometria",
                          idMapa: "mapaAnaliseGeomensor",
                          errors: [],
                          addPonto: true
                        },
                        on: {
                          shapefileUploaded: _vm.setShapefile,
                          shapefileRemoved: _vm.removeShapefile
                        },
                        model: {
                          value: _vm.conflito.geometrias,
                          callback: function($$v) {
                            _vm.$set(_vm.conflito, "geometrias", $$v)
                          },
                          expression: "conflito.geometrias"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "container-buttons" },
        [
          _c(
            "el-button",
            { staticClass: "cancelar", on: { click: _vm.cancelar } },
            [_c("i", { staticClass: "fa fa-times" }), _vm._v("  Cancelar")]
          ),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.salvar } },
            [_c("i", { staticClass: "fa fa-check" }), _vm._v("  Concluir")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2f913b34", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2f913b34","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/ouvidoria/Conflito.vue
// module id = null
// module chunks = 